import { render } from "./FormStart.vue?vue&type=template&id=1394ba0a"
import script from "./FormStart.vue?vue&type=script&lang=js"
export * from "./FormStart.vue?vue&type=script&lang=js"

import "./FormStart.vue?vue&type=style&index=0&id=1394ba0a&lang=scss"

import exportComponent from "/Users/billyhan/Sites/sol-v3/web/wp-content/themes/swinburne/assets/Eligibility/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__